import { render } from "./Current_calls_card.vue?vue&type=template&id=5428af2c&scoped=true"
import script from "./Current_calls_card.vue?vue&type=script&lang=js"
export * from "./Current_calls_card.vue?vue&type=script&lang=js"

import "./Current_calls_card.vue?vue&type=style&index=0&id=5428af2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5428af2c"]])

export default __exports__